import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AiIcon } from '@/shared/assets/icons/ai-icon';
import {
  AiLoaderContainer,
  IconWrapper,
  MessageText,
} from '@/shared/components/ui/ai-loader/ai-loader.styled';
import { TAiLoaderProps } from '@/shared/components/ui/ai-loader/ai-loader.types';

const MESSAGE_KEYS = [
  'analyzing_data',
  'consulting_neural_network',
  'crunching_numbers',
  'almost_there',
  'working_magic',
] as const;

const MESSAGE_INTERVAL_MS = 3000;

export const AiLoader: React.FC<TAiLoaderProps> = ({
  messages: messagesProp,
  showIcon = true,
}) => {
  const { t } = useTranslation();
  const [messageIndex, setMessageIndex] = useState(0);

  const messages =
    messagesProp ?? MESSAGE_KEYS.map((key) => t(`ai_loader:${key}`));

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, MESSAGE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <AiLoaderContainer $compact={!showIcon}>
      {showIcon && (
        <IconWrapper>
          <AiIcon />
        </IconWrapper>
      )}
      <MessageText key={messageIndex}>{messages[messageIndex]}</MessageText>
    </AiLoaderContainer>
  );
};
